import {ISettingsState} from './Reducer';
import {createSelector} from '@reduxjs/toolkit';
import {selectSession} from '../session/Selectors';
export const selectSettingsState = (state: { settings: ISettingsState }) => state.settings;


export const selectBreakSettingsListResultLoading = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsListResultLoading
);
export const selectBreakSettingsListResultError = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsListResultError
);
export const selectBreakSettingsListResult = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsListResult
);

export const selectBreakSettingsLoading = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsLoading
);
export const selectBreakSettingsError = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsError
);
export const selectBreakSettingsSaving = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsSaving
);
export const selectBreakSettingsSaveError = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsSaveError
);
export const selectBreakSettingsDetail = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsDetail
);
export const selectEditBreakSettingsDetail = createSelector(
  selectSettingsState,
  (subState) => subState.breakSettingsEditDetail
);

export const selectUserPreferencesInit = createSelector(
  selectSettingsState,
  (state) => state.userPreferencesInit
);
export const selectUserPreferencesLoading = createSelector(
  selectSettingsState,
  (subState) => subState.userPreferencesLoading
);
export const selectUserPreferencesLoadingError = createSelector(
  selectSettingsState,
  (subState) => subState.userPreferencesLoadingError
);
export const selectUserPreferencesSaving = createSelector(
  selectSettingsState,
  (subState) => subState.userPreferencesSaving
);
export const selectUserPreferencesSaveError = createSelector(
  selectSettingsState,
  (subState) => subState.userPreferencesSaveError
);
export const selectUserPreferences = createSelector(
  selectSettingsState,
  (subState) => subState.userPreferences
);
